module.exports = __webpack_public_path__ + "static/images/delete-cross.3_FEuJW.svg";